import { ProductMapper } from 'mappers/product';
import { ProductActionTypes } from './actionTypes';
import { ProductTransformations } from 'modules/productBrowser/transformation';

const getProductBrowser = () => (dispatch, getState, { api }) => {
  dispatch({
    type: ProductActionTypes.PRODUCT_BROWSER.FETCH,
    payload: {},
    test: api
      .post(`productList.json`)
      .then(res => {
        const response = res || [];
        const products = ProductTransformations.formatProducts(response);
        dispatch({
          type: ProductActionTypes.PRODUCT_BROWSER.SUCCESS,
          payload: products,
        });

        const productFilters = ProductMapper.extractProductFilters(products);
        dispatch({
          type: ProductActionTypes.PRODUCT_FILTERS.INITIALIZE,
          payload: productFilters,
        });
      })
      .catch(error => {
        dispatch({
          type: ProductActionTypes.PRODUCT_BROWSER.FAILURE,
          error,
        });
      }),
  });
};

const getProductDetails = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: ProductActionTypes.PRODUCT_DETAILS.FETCH,
    payload: {},
    test: api
      .post(`productDetail.json`, { product_url_slug: url_slug })
      .then(res => {
        const response = res || [];
        dispatch({
          type: ProductActionTypes.PRODUCT_DETAILS.SUCCESS,
          payload: ProductTransformations.transformProductDetails(response),
        });
      })
      .catch(error => {
        dispatch({
          type: ProductActionTypes.PRODUCT_DETAILS.FAILURE,
          error,
        });
      }),
  });
};

const toggleProductFilter = (type, value) => dispatch => {
  dispatch({
    type: ProductActionTypes.PRODUCT_FILTERS.TOGGLE_FILTER,
    payload: {
      type,
      value,
    },
  });
};

const clearProductFilters = () => dispatch => {
  dispatch({
    type: ProductActionTypes.PRODUCT_FILTERS.CLEAR_FILTERS,
  });
};

export const ProductBrowserAction = {
  getProductBrowser,
  getProductDetails,
  toggleProductFilter,
  clearProductFilters,
};
